<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="closeBooKDates"
        :show-search="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
    >
      <template slot="actionBtn" slot-scope="scope">
        <el-switch
            v-model="scope.row.status"
            style="margin: 0 10px;"
            :active-value="true"
            :inactive-value="false"
            active-text="启用"
            inactive-text="停用"
            inactive-color="#F56C6C"
            @change="statusChange(scope.row)"/>
      </template>
    </view-table>
    <close-book-date-edit ref="closeBookDateEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import CloseBookDateEdit from "./CloseBookDateEdit";

  export default {
    name: "CloseBookDateList",
    components: {CloseBookDateEdit, ViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(766),
          editAuth: this.$auth(767),
          delAuth: this.$auth(768),
        },
        filter: {
          closeBookBeginDate: "",
          closeBookEndDate: "",
          chooseBookDate: "",
          bookType: "",
        },
        columnsProperty: [
          {
            key: "closeBookBeginDate",
            title: "关账开始日期",
            width: 180,
            align: "center",
          },
          {
            key: "closeBookEndDate",
            title: "关账结束日期",
            width: 180,
            align: "center",
          },
          {
            key: "chooseBookDate",
            title: "记账日期",
            width: 180,
            align: "center",
          },
          {
            key: "creatorTime",
            title: "创建日期",
            width: 180,
            align: "center",
          },
          {
            key: "creatorName",
            title: "创建人",
            width: 120,
            align: "center",
          },
          {
            key: "bookTypeDesc",
            title: "管控类型",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h("span", params.row.bookType === 1 ? "签收" : "非签收");
            },
          },
          {
            key: "status",
            title: "状态",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h("span", params.row.status ? "启用" : "停用");
            },
          },
          {
            key: "action",
            title: "操作",
            width: 268,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.closeBookDateEdit.open(row);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "closeBooKDates", row.pkId).then(res => {
          if (res.success) {
            this.$message.success("删除成功");
            this.loadData(1);
          }
        });
      },

      statusChange(row) {
        this.$http.save("basic", "closeBooKDates", row).then(res => {
          if (res.success) {
            this.$message.success("状态更新成功");
          } else {
            // 状态更新失败，恢复原状态
            row.status = row.status ? false : true;
          }
        }).catch(() => {
          // 状态更新失败，恢复原状态
          row.status = row.status ? false : true;
        });
      },
    },
  };
</script>